export default {
    displayFormat: function(value) {
        value = value.replace(/,/g, '.').replace(/ /g, '');
        return ['', '.'].indexOf(value)>-1 ? '' : vx.formatting.formatNumber(value, 0, ',', ' ');
    },
    modelFormat: function(value) {
        return value.replace(/\s/g,'');
    }
}